import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { Config, WL_CONFIG } from './app/config/config';
import { ConfigProvider } from '@mydocma/common';

if (environment.production) {
  enableProdMode();
}

async function main() {

  try {
    const configProvider = new ConfigProvider<Config>(null);
    const config = await configProvider.loadConfigAsync();

    await platformBrowserDynamic([
      {provide: WL_CONFIG, useValue: config}
    ]).bootstrapModule(AppModule).then(() => {
      /*if ('serviceWorker' in navigator && environment.production) {
        navigator.serviceWorker.register('ngsw-worker.js');
      }*/
    })
  } catch (error) {
    console.error(error);
  }
}

main();
